module.exports = __webpack_public_path__ + "static/media/USD.a195760a.svg";